import React from "react";

const Tech = ({ text }) => {
  return (
    <p className="border rounded-full px-2 py-1 font-medium text-xs text-dark uppercase">
      {text}
    </p>
  );
};

export default Tech;
